module.exports = __webpack_public_path__ + "static/media/blog3_3.e1756175.webp";